import { DescriptionPage_PremiumExperienceVariant as PremiumExperienceVariant } from '__generated__/graphql-types';

import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';
import type { CoursePrice } from 'bundles/seo/components/course-rich-search-card/types';
import { CoursePrices } from 'bundles/seo/components/course-rich-search-card/types';

function getCoursePriceOffer(
  hit: SearchProductHit,
  premiumExperienceVariant?: PremiumExperienceVariant
): CoursePrice | undefined {
  const isAuditableCourse = premiumExperienceVariant === PremiumExperienceVariant.PremiumGrading;

  if (hit.isCourseFree) {
    return CoursePrices.Free;
  }
  if (hit.isPartOfCourseraPlus) {
    return CoursePrices.PartOfCourseraPlus;
  }

  if (isAuditableCourse && !hit.isPartOfCourseraPlus) {
    return CoursePrices.Auditable;
  }

  return undefined;
}

export default getCoursePriceOffer;
